<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="620px"
        @close="handleClose">
        <div style="width:310px;margin: 0 auto">
            <div class="f info" style="margin-bottom: 10px">
                <div class="image">
                    <img src="../../../assets/img/Group2100.png" style="width:60px;height:62px">
                </div>
                <div class="font">
                    <h2>{{ $t('commodity.Components.AddingToBag.AddingToBagSucceed') }}</h2>
                    <p>
                        {{ $t('commodity.Components.AddingToBag.Item') }}:
                        <span style="color: #99C41C">{{productNum}}</span>
                    </p>
                    <p>
                        {{ $t('commodity.Components.AddingToBag.Subtotal') }}:
                        <span style="color: #E3444E">$ {{addPriceTotal}}</span>
                    </p>
                </div>
            </div>
            <div class="btn">
                <el-button type="primary" icon="el-icon-goods" @click="$router.push('/mall/shoppingCar')">
                    {{ $t('commodity.Components.AddingToBag.ViewMyBag') }}
                </el-button>
            </div>
            <div class="btn">
                <el-button icon="el-icon-house" @click="handleClose">{{ $t('commodity.Components.AddingToBag.ContinueShopping') }}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
  props: {
    sizePriceTotal: {
      type: String || Number,
      default: 0
    }
  },
  data() {
    return {
      dialogVisible: false,
      addList: []
    }
  },
  computed: {
    addPriceTotal() {
      return this.addList.reduce((current, next) => {
        if (next.afterDiscountAmount) return current + (next.afterDiscountAmount * 1000) * (next.num * 1000) / 1000000
        return current + (next.price * next.num)
      }, 0).toFixed(2)
    },
    productNum() {
      return this.addList.reduce((current, next) => {
        return current + parseInt(next.num)
      }, 0)
    }
  },
  methods: {
    handleClose() {
      this.addList = []
      this.dialogVisible = false
      this.$emit('closeAddDialog')
    },
    show(addList) {
      /*
        addList: [price: 100, num: 100]
      */
      this.addList = addList
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.btn{
    width: 100%;
    margin-bottom: 14px;
    button{
        width: 100%;
        /deep/.el-icon-goods{
            font-size: 16px;
        }
        /deep/.el-icon-house{
            font-size: 16px;
        }
    }
}
.info{
    .image{
        margin-right: 14px;
        padding-top: 8px;
    }
    .font {
        h2{
            font-size: 20px;
            line-height: 42px;
        }
        >p {
            font-size: 16px;
            line-height: 26px;
        }
    }
}
</style>
